import './App.css';
import AllRoutes from './components/AllRoutes';
import Navbar from './components/Navbar';

import './components/Global.scss'

function App() {
  return (
    <div>
      <Navbar/>
      <AllRoutes/>
    </div>
  );
}

export default App;